import { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from "react-lazy-load-image-component";
// import { QualityAssuranceServiceData } from "../../common";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
// core components
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import AboutUsBanner from "../../components/AboutUs/AboutUsBanner";
import CustomerReviews from "../../components/CustomerReviews/CustomerReviews";
import ContactUsComponent from "../../components/ContactUsComponent/ContactUsComponent";
import FrequentlyAskedQuestions from "../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions";
// import testImg from '../../assets/images/qualityAssurance/Vector-7538.png'
// import { Helmet } from "react-helmet";
// import { getIPGeoLocation } from "../../common/GeneralUtils";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import * as Icons from '../../common/icons/qualityAssuranceServiceDataIcons';
import Toasts from "../../components/Toasts/Toasts";

// import Loadable from "../../components/Loadable"

// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )
// const Footer = Loadable(
//     lazy(() => import('../../components/footer/footer'))
// )
// const AboutUsBanner = Loadable(
//     lazy(() => import('../../components/AboutUs/AboutUsBanner'))
// )
// const CustomerReviews = Loadable(
//     lazy(() => import('../../components/CustomerReviews/CustomerReviews'))
// )
// const ContactUsComponent = Loadable(
//     lazy(() => import('../../components/ContactUsComponent/ContactUsComponent'))
// )
// const FrequentlyAskedQuestions = Loadable(
//     lazy(() => import('../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions'))
// )
// const testImg = Loadable(
//     lazy(() => import('../../assets/images/qualityAssurance/Vector-7538.png'))
// )

const QualityAssuranceServiceScreen = () => {
    // const location = useLocation();
    const [toasts, setToasts] = useState(null)
    const [WebAppDevelopmentData, setData] = useState({});
    const [QualityAssuranceServiceData, setQualityAssuranceServiceData] = useState({});
    const [geoLocationData, setGeoLocationData] = useState(null);

    const getAllWebAppDevelopmentData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/webAppDevelopmentData.json');
            setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }
    const getAllQualityAssuranceServiceData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/qualityAssuranceServiceData.json');
            setQualityAssuranceServiceData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    useEffect(() => {
        // getIPGeoLocation(location.pathname);
        getAllWebAppDevelopmentData();
        getAllQualityAssuranceServiceData();
    }, [])
    return (
        <Fragment>
            <Helmet>
                <title>Software Quality Assurance Services for Scalable Software</title>
                <meta name="description" content="Looking for software quality assurance services? VarahiSoft delivers end-to-end testing to improve performance, security and user experience." />
                <meta name="keywords" content="software quality assurance services" />
                <meta property="og:title" content="Software Quality Assurance Services for Scalable Software" />
            </Helmet>
            <div id="main-wrapper">
                <Header geoLocation={setGeoLocationData} />
                <div className="page-wrapper quality-assurance-service-page-wrapper">
                    <div className="container-fluid">
                        <div className="page-content-top">
                            <AboutUsBanner bannerImg={QualityAssuranceServiceData?.bannerImg} data={QualityAssuranceServiceData?.headerData} />
                            <div className="content-tech-page-warper">
                                <Container>
                                    <div className="page-context-text">
                                        <h2>{QualityAssuranceServiceData?.elevateExcellence?.title}</h2>
                                    </div>
                                </Container>
                            </div>
                            <section className="elevateExcellence">
                                <Container>
                                    <Row>
                                        <Col lg={6} md={6} sm={6} className="elevate-excellence pe-5 d-flex align-items-center justify-content-center">
                                            <div className="revolutionize-content pe-5">
                                                {QualityAssuranceServiceData?.elevateExcellence?.paragraph?.length > 0 && QualityAssuranceServiceData?.elevateExcellence?.paragraph?.map((text, index) => <p key={index}>{text.text}</p>)}
                                            </div>
                                        </Col>
                                        <Col lg={6} md={6} sm={6}>
                                            <div className="img-div-width">
                                                <LazyLoadImage
                                                    alt={'image'}
                                                    className="w-100"
                                                    effect="blur"
                                                    src={QualityAssuranceServiceData?.elevateExcellence?.pageImg} // use normal <img> attributes as props
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                            <section className="assurance-warper">
                                <Container className="assurance-warper-container">
                                    <Row>
                                        <Col lg={6} md={6} >
                                            <Card className="assurance-warper-card">
                                                <CardHeader>{QualityAssuranceServiceData?.assurance?.whatisQualityAssurance?.title}</CardHeader>
                                                <CardBody>{QualityAssuranceServiceData?.assurance?.whatisQualityAssurance?.paragraph?.map((para, index) => {
                                                    return (
                                                        <p key={index}>{para?.text} <b>{para?.bold}</b> {para?.text1} <b>{para?.bold1}</b> {para?.text2} <b>{para?.bold2}</b></p>
                                                    )
                                                })}</CardBody>
                                            </Card>
                                        </Col>
                                        <Col lg={6} md={6} >
                                            <Card className="assurance-warper-card">
                                                <CardHeader>{QualityAssuranceServiceData?.assurance?.whyQualityAssuranceMatters?.title}</CardHeader>
                                                <CardBody>{QualityAssuranceServiceData?.assurance?.whyQualityAssuranceMatters?.paragraph?.map((para, index) => {
                                                    return (
                                                        <Fragment key={index}>
                                                            <p>{para?.text}</p>
                                                            {para?.listData?.length > 0 && <ul className="card-inner-ul">
                                                                {para?.listData?.map((list, listIndex) => {
                                                                    return (
                                                                        <li className="p-1 pe-5" key={listIndex}><span className="listColor">{list?.title}</span> {list?.text}</li>
                                                                    )
                                                                })}
                                                            </ul>
                                                            }
                                                        </Fragment>
                                                    )
                                                })}
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                            <section className="core-mobile-app-section-warper">
                                <Container>
                                    <h3>{QualityAssuranceServiceData?.CoreServices?.title}</h3>
                                    <h4>{QualityAssuranceServiceData?.CoreServices?.subtitle}</h4>
                                    <div className="core-mobile-app-card">
                                        <Row className="m-0">
                                            {QualityAssuranceServiceData?.CoreServices?.listData?.map((cardItem, index) => {
                                                const Icon = Icons[cardItem?.icon] || null;
                                                return <Col key={index} md={4} lg={4} sm={6} xs={12}>
                                                    <Card className="app-card">
                                                        <CardBody>
                                                            {cardItem?.icon && <p>
                                                                {Icon && <Icon />}
                                                            </p>}
                                                            <h5 className="card-title-div">{cardItem?.title}</h5>
                                                            <p><span>{cardItem?.text}</span>{cardItem?.bold && <span>{cardItem?.bold}</span>}{cardItem?.text1 && <span>{cardItem?.text1}</span>}</p>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            })}
                                        </Row>
                                    </div>
                                </Container>
                            </section>
                            <section className="core-mobile-app-process" >
                                <Container>
                                    <h3>{QualityAssuranceServiceData?.WhyChooseVarahiSoftforECommerceDevelopment?.title}</h3>
                                    <h4 className="pe-5">{QualityAssuranceServiceData?.WhyChooseVarahiSoftforECommerceDevelopment?.subTitle}</h4>
                                    <div className="core-mobile-app-card pt-5">
                                        <Row>
                                            <Col lg={6} md={6} xs={12} className="d-flex align-items-center">
                                                <div className="img-div-width">
                                                    <LazyLoadImage
                                                        alt={'image'}
                                                        className="w-100"
                                                        effect="blur"
                                                        src={QualityAssuranceServiceData?.WhyChooseVarahiSoftforECommerceDevelopment?.pageImg} // use normal <img> attributes as props
                                                    />
                                                </div>
                                            </Col>
                                            <Col className="content-body" lg={6} md={6} xs={12}>
                                                {QualityAssuranceServiceData?.WhyChooseVarahiSoftforECommerceDevelopment?.listData?.map((chooseData, index) => {
                                                    const ChooseDataIcon = Icons[chooseData?.icon] || null;
                                                    return (
                                                        <div key={index} className="px-5 d-flex align-items-start justify-content-start gap-3">
                                                            <div className="why-choose-icon">{ChooseDataIcon && <ChooseDataIcon />}</div>
                                                            <div className="why-cho0se-body">
                                                                <h5>
                                                                    {chooseData?.title}
                                                                </h5>
                                                                <p>{chooseData?.text}</p>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </Col>
                                        </Row>
                                    </div>
                                </Container>
                            </section>
                            <section className="our-proven-qA-process-warper">
                                <Container>
                                    <h3>{QualityAssuranceServiceData?.OurProvenQAProcess?.title}</h3>
                                    <h4 className="pe-5">{QualityAssuranceServiceData?.OurProvenQAProcess?.subTitle}</h4>
                                    {/* <div className="qa-banner my-5">Structured, time-tested QA methodology</div> */}
                                    <div className="qa-banner-2 my-5 position-relative">
                                        <LazyLoadImage
                                            alt={'image'}
                                            className="w-100"
                                            effect="blur"
                                            src={'/assets/images/qualityAssurance/Vector-7538.png'} // use normal <img> attributes as props
                                        />
                                        <p className="position-absolute">{QualityAssuranceServiceData?.OurProvenQAProcess?.listTitle}</p>
                                    </div>
                                    <div className="qa-steps">
                                        {QualityAssuranceServiceData?.OurProvenQAProcess?.listData.map((step) => (
                                            <div className="qa-step" key={step.number}>
                                                <div className="qa-step-number">{step.number}</div>
                                                <div className="qa-step-title">{step.title}</div>
                                                <div className="qa-step-desc">{step.description}</div>
                                            </div>
                                        ))}
                                    </div>
                                </Container>
                            </section>
                            <section className='Tech-Industry-Quality'>
                                <div className='tech-content' style={{ backgroundImage: `url(${QualityAssuranceServiceData?.TurningIdeas?.bgImg})` }}>
                                    <div className="bg-color-rgba">
                                        <Container className="ps-5">
                                            <Row className="justify-content-end">
                                                <Col lg="7" md="7" className="align-self-start">
                                                    <div className='page-content'>
                                                        <h3>{QualityAssuranceServiceData?.TurningIdeas?.title}</h3>
                                                        {QualityAssuranceServiceData?.TurningIdeas?.paragraph?.map((para, index) => {
                                                            return (
                                                                <p key={index}>{para?.text}<Link className='text-decoration-none text-white' to={window?.location?.origin}>{para?.link}</Link> {para?.text1}</p>
                                                            )
                                                        })}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </section>
                            <CustomerReviews />
                            <div className="home-contact-page">
                                <ContactUsComponent setToasts={setToasts} GeoIpData={geoLocationData} />
                            </div>
                            <FrequentlyAskedQuestions faqData={WebAppDevelopmentData?.FrequentlyAskedQuestionsData} />
                        </div>
                    </div>
                </div>
                <Footer />
                {toasts && <Toasts toastsList={toasts} />}
            </div>
        </Fragment>
    );
}

QualityAssuranceServiceScreen.propTypes = {
    classes: PropTypes.object
};

export default QualityAssuranceServiceScreen;
